import React from "react";
import { Link } from "react-router-dom";
import { FOOTER } from "../data/mock";

// Map footer labels to real destinations; unknown labels are inert (#).
const LINK_MAP = {
  Features: "/#features",
  Pricing: "/#pricing",
  FAQs: "/faq",
  Tutorials: "/tutorials",
  Blog: "/blog",
  "About LWA": "/about",
  Press: "/press",
  Terms: "/terms",
  Privacy: "/privacy",
  "Contact Us": "/contact",
  Facebook: "https://www.facebook.com/lifewithabba",
  Instagram: "https://www.instagram.com/lifewithabba/",
  Twitter: "https://twitter.com/lifewithabba",
  TruthSocial: "https://truthsocial.com/@LifeWithAbba",
  "Facebook Group": "https://www.facebook.com/groups/lifewithabba",
};

function FooterLink({ label }) {
  const dest = LINK_MAP[label] || "#";
  const cls =
    "font-serif-body text-[#7a7a7a] text-[15px] hover:text-[#68c2d5] transition-colors";

  // External links (social, community) open in a new tab.
  if (dest.startsWith("http")) {
    return (
      <a href={dest} target="_blank" rel="noreferrer" className={cls}>
        {label}
      </a>
    );
  }
  if (dest === "#" || dest.includes("#")) {
    return (
      <a href={dest} className={cls}>
        {label}
      </a>
    );
  }
  return (
    <Link to={dest} className={cls}>
      {label}
    </Link>
  );
}

function Column({ title, items }) {
  return (
    <div>
      <p className="font-serif-display text-[#333] text-lg font-bold tracking-wide uppercase">
        {title}
      </p>
      <ul className="mt-4 space-y-2">
        {items.map((it) => (
          <li key={it}>
            <FooterLink label={it} />
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-100">
      <div className="max-w-6xl mx-auto px-5 py-16 grid grid-cols-2 md:grid-cols-5 gap-10">
        <Column title="Get The App" items={FOOTER.getApp} />
        <Column title="Offers" items={FOOTER.offers} />
        <Column title="About" items={FOOTER.about} />
        <Column title="Help" items={FOOTER.help} />
        <Column title="Social" items={FOOTER.social} />
      </div>
      <div className="border-t border-gray-100 py-6">
        <p className="font-serif-body text-center text-[#888] text-[13px] px-5">
          Copyright &copy; 2026 by NexLev Solutions, LLC. All rights reserved. Life
          With Abba is owned and operated by NexLev Solutions, LLC.
        </p>
      </div>
    </footer>
  );
}
